export const penniesToDollars = (pennies: number): number => pennies / 100;

export const fractionalPenniesToDollars = (pennies: number): number => pennies / 10000;
